// utilities
import { debounce } from './_utilities/debounce.js';
import { throttle } from './_utilities/throttle.js';
import { triggerEvent } from './_utilities/trigger-event.js';
import { is_mobile } from './_utilities/navigator.js';

//components

//modules
// import { Hero } from './modules/hero/index';
import { Form } from './modules/form/index';

/**
 * Binds all events to DOM objects.
 * @function _bindEvents
 */
function _bindEvents() {
  window.addEventListener(
    'resize',
    debounce(() => triggerEvent(window, 'resize:smart'), 250)
  );
  window.addEventListener(
    'scroll',
    throttle(() => triggerEvent(window, 'scroll:smart'), 250),
    { passive: true }
  );
}

_bindEvents();

Form();

